// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import ActionBar from '../../layout/ActionBar';
import DisabledReasonForm from './components/DisabledReasonForm';
import Loading from '../../common/Loading';
import DeleteDisabledReason from './slideout/DeleteDisabledReason';
import SlidingPane from 'react-sliding-pane';
import { useTranslation } from 'react-i18next';
import ResponsiveActionBarButtons from '../../common/ResponsiveActionBarButtons';
import Button from '../../common/Button';
import { usePageTitle } from '../../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../hooks';
import { saveDisableReason } from '../../../reducers/disableReasonReducer';
import { getDisableReasonById } from '../../../api/keyCodeApi';

function DisabledReason() {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const { id } = useParams();

  const [pageTitle, setPageTitle] = usePageTitle([
    'Disabled reasons',
    'Settings',
  ]);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  
  const [deleteSlideoutOpen, setDeleteSlideoutOpen] = useState(false);
  const navigate = useNavigate();

  const handleDelete = (e) => {
    e.cancelBubble = true;
    setDeleteSlideoutOpen(true);
    return false;
  };
  const onSubmit = (data) => {
    dispatch(saveDisableReason({ ...disableReason, ...data }))
      .unwrap()
      .then(() => {
        toast.success(t('Disabled reason saved'));
      });
  };

  const [disableReason, setDisableReason] = useState({});

  useEffect(() => {
    if (id) {
      getDisableReasonById(id)
        .then((d) => {
          setDisableReason(d);
          setPageTitle([d.reason, 'Disabled reasons', 'Settings']);
        })
        .catch((e) => {
          console.error(e);
          navigate('/settings/disabled-reasons/');
          toast.error(t('Disabled reason not found'));
        });
    }
  }, [id, t, setPageTitle, navigate]);

  return disableReason ? (
    <>
      <ActionBar
        breadcrumb={[
          { link: '/settings/disabled-reasons', label: t('Disabled reasons') },
          { label: disableReason.reason },
        ]}
      >
        <div className="d-flex">
          <ResponsiveActionBarButtons
            buttons={[
              id && (
                <Button
                  className="btn btn-danger ms-2 d-none d-md-inline-flex"
                  onClick={handleDelete}
                  text={t('Delete')}
                />
              ),
              <Button
                key="save"
                className="btn btn-primary ms-2"
                onClick={handleSubmit(onSubmit)}
                text={t('Save')}
              />,
            ]}
          />
        </div>
      </ActionBar>

      <DisabledReasonForm
        disabledReason={disableReason}
        register={register}
        errors={errors}
      />

      <SlidingPane
        isOpen={deleteSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setDeleteSlideoutOpen(false)}
      >
        <DeleteDisabledReason
          id={id}
          done={(d) => {
            navigate('/settings/disabled-reasons/');
            setDeleteSlideoutOpen(false);
          }}
          cancel={() => setDeleteSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  ) : (
    <Loading />
  );
}

export default DisabledReason;
